import React from 'react'
import Axios from 'axios'
import DetalhamentoPedido from '../_Components/DetalhamentoPedido'
import CambistaTemplate from './CambistaTemplate'
import moment from 'moment';
import { Link } from 'react-router-dom';

export class ReceberPedidos extends React.Component {
    constructor(props) {
        window.localStorage.setItem("rotaAtual", window.location.href.split('/')[3]);
        super(props)
        this.state = {
            pedidos: {},
            user: JSON.parse(localStorage.getItem('user')),
            codigoBusca: '',
            clienteSelecionado: null,
            pedidoSelecionado: null,
            sac: "99999999999",
            cartelas: []
            
        }
        this.currentUser();
        this.getSAC();
        this.listarPedidos()
        this.receberPedido = this.receberPedido.bind(this)
        this.buscarPedido = this.buscarPedido.bind(this)
        this.setCodigoBusca = this.setCodigoBusca.bind(this)
        this.selecionarPedido = this.selecionarPedido.bind(this)
        this.deselecionarPedido = this.deselecionarPedido.bind(this)
        this.imprimirCartelas = this.imprimirCartelas.bind(this)
        this.imprimirCartelasWebView = this.imprimirCartelasWebView.bind(this)
    }

    async getSAC() {
        try {
            var axiosInstance = new Axios.create({baseURL: window.localStorage.getItem("apiUrl")});
            const response = await axiosInstance.get("parametros/get-sac");
            this.setState({sac: response.data.contatoSAC});
        } catch (err) {
            console.log(err);
        }
    }
    async currentUser() {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.get('usuarios/' + this.state.user._id)
            this.setState({ user: response.data })
        } catch (err) {
            console.log(err)
        }
    }

    imprimirCartelas(e) {
        var item = JSON.parse(e.target.accessKey)
        var printContents =
            `<html>
            <head>
             <meta charset="utf-8"/>
                <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
                <title>
                    SorteFlash
                </title>
                <meta
                        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0, shrink-to-fit=no"
                        name="viewport"
                />
                <link to="/assets/css/bootstrap.min.css" rel="stylesheet"/>
        
        </head>
            <body onload='window.print()'>
            <div class='border border-dark text-dark font-weight-bold text-center rounded' ><h4 class="text-dark font-weight-bold" >SORTEFLASH - SORTEIO ${this.formatDate(item.cartelas[0].data)}</h4></div>
            <div class="border-bottom mt-3"><h5>Pedido: ${item.codigo}</h5></div>
            <div class="border-bottom mt-3"><h5>Cliente: ${item.clienteId.nome}</h5></div>
            <h5>Contato: ${item.clienteId.telefone}</h5>
            <h5>Endereço: ${item.clienteId.cidade != undefined ? item.clienteId.cidade : ""} -  ${item.clienteId.bairro != undefined ? item.clienteId.bairro : ""}</h5>
            <div class="border-bottom mb-3"><h5 >Cambista: ${item.cambistaId.nome}</h5></div>
            ${item.cartelas ?
                item.cartelas.map((cartela, index) => {
                    return (
                        `
                                 <div
                                   class="mt-2 bg-light rounded"
                                   style="min-width: '100% !important'; height: '10em';"
                     
                                 >
                                ${cartela.numeros ?

                            `<div class="container text-dark border border-dark" style="min-width: '100%'; height: '10em';">
                                <div class="row  border border-dark text-dark font-weight-bold text-center justify-content-center">
                                    <h4 class='text-dark font-weight-bold'><span class='text-dark font-weight-bold'>Cartela: ${cartela.codigo}</span></h4>
                                </div>
                                <div class="row border border-dark">
                                  <div class='col border border-dark text-center'>
                                  <h4><span >${cartela.numeros[0]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4> <span>${cartela.numeros[1]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4> <span>${cartela.numeros[2]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[3]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[4]}</span></h4>
                                  </div>
                                </div>
                                <div class="row border border-dark">
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[5]}</span></h4>
                                  </div>
                                  <div class='col border  border-dark text-center'>
                                  <h4><span>${cartela.numeros[6]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[7]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[8]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[9]}</span></h4>
                                  </div>
                                </div>
                                <div class="row border border-dark">
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[10]}</span></h4>
                                  </div> 
                                  <div class='col border border-dark text-center'>
                                    <h4><span>${cartela.numeros[11]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[12]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[13]}</span></h4>
                                  </div>
                                  <div class='col border border-dark text-center'>
                                  <h4><span>${cartela.numeros[14]}</span></h4>
                                  </div>
                                </div>
                              </div>`

                            : ""}
                                 </div>
                         `);
                })
                : ""}
                     <div class='border border-dark text-dark text-center rounded' ><h4 class="text-dark font-weight-bold" >SORTEFLASH - SORTEIO ${this.formatDate(item.cartelas[0].data)} - ${item.cartelas[0].horario}</h4></div>
                     <div class='border border-dark text-dark  text-center rounded'  ><h4 class="text-dark font-weight-bold" >PREÇO UNITARIO: R$ ${item.cartelas[0].valor} </h4></div>
                     <div class=" text-dark  font-weight-bold w-100 text-center justify-content-center">
                     <div class='row  ' style={{fontSize: '0.8em'}}><span class="mt-3 ml-3 font-weight-bold" >1º PRÊMIO</span> <span class="ml-2 font-weight-bold" style={{fontSize: '1.5em'}} >2000,00</span> <span class="mt-3 ml-2 font-weight-bold" >LINHA HORIZONTAL</span> </div>
                     <div class='row  ' style={{fontSize: '0.8em'}}><span class="mt-3 ml-3 font-weight-bold" >2º PRÊMIO</span> <span class="ml-2 font-weight-bold" style={{fontSize: '1.5em'}} >2000,00</span> <span class="mt-3 ml-3 font-weight-bold" >CRUZADINHA</span> </div>
                     <div class='row ' style={{fontSize: '0.8em'}}><span class="mt-3 ml-3 font-weight-bold" >3º PRÊMIO</span> <span class="ml-2 font-weight-bold" style={{fontSize: '1.5em'}} >Pop 110 ou 6Mil</span> <span class="mt-3 ml-2 font-weight-bold" >CHEIA</span> </div>
                     <div class='row ' style={{fontSize: '0.8em'}}><span class="mt-3 ml-3 font-weight-bold" >4º PRÊMIO</span> <span class="ml-2 font-weight-bold" style={{fontSize: '1.5em'}} >5000,00</span> <span class="mt-3 ml-2 font-weight-bold" >50 GIROS DE 100</span> </div>
                     <div class='row  ' style={{fontSize: '0.8em'}}><span class="mt-3 ml-3 font-weight-bold" >BÔNUS</span> <span class="ml-4 font-weight-bold" style={{fontSize: '1.5em'}} >5000,00</span> <span class="ml-3 mt-3  ml-2 font-weight-bold" >DUPLO ACERTO</span> </div>
                     <div class='row  justify-content-center  text-center ' style={{fontSize: '0.85em'}}><span class="ml-3 font-weight-bold" >Informações no Whatsapp ${this.state.sac}</span> </div>
                     <div class='row  justify-content-center text-center ' style={{fontSize: '1.2em'}}><span class="ml-3 font-weight-bold" >www.sorteflash.com</span> </div>
                     </div>
                     </body>
        </html>`

        var newWin = window.frames["printf"];
        newWin.document.write(printContents);
        // newWin.location.href = 'gonative://share/sharePage'; 
        newWin.document.close();

    }

    imprimirPedido(e) {
        localStorage.setItem('printItem', e.target.accessKey)
        window.location.href = '/imprimir?pedido=' + e.target.accessKey;
    }

    imprimirCartelasWebView(e) {
        localStorage.setItem('printItem', e.target.accessKey)
        this.props.history.push('/imprimir?pedido=' + JSON.parse(e.target.accessKey)._id);

    }

    deselecionarPedido(event) {
        this.setState({ pedidoSelecionado: null, clienteSelecionado: null })
        this.forceUpdate()
    }

    selecionarPedido(event) {
        const pedido = JSON.parse(event.target.accessKey)
        this.setState({
            pedidoSelecionado: event.target.accessKey,
            clienteSelecionado: JSON.stringify(pedido.clienteId)
        })
        console.log(this.state.pedidoSelecionado)
        this.forceUpdate()
    }



    formatDate(data) {
        return moment(data).add(0, 'days').format('DD-MM-YYYY')
    }

    getUser = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('usuarios/user', {
                id: this.state.user._id
            })

            window.localStorage.setItem('user', JSON.stringify(response.data[0]))
            this.setState({ user: response.data[0] })
        } catch (err) {
            console.log(err)
        }
    }

    listarPedidos = async (e) => {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('pedidos/listar-pedidos', {
                id: this.state.user._id
            })
            this.setState({ pedidos: response.data.reverse() })
            console.log( response.data )
            this.contarCartelas()
        } catch (err) {
            console.log(err)
        }
    }

    async receberPedido(e) {
        e.target.disabled = true
        const index = e.target.name
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('transacoes/criar-transacao', {
                data: new Date(),
                documento: this.state.pedidos[index].codigo,
                valor: this.state.pedidos[index].cartelas.length * this.state.pedidos[index].cartelas[0].valor,
                emissorId: this.state.pedidos[index].clienteId,
                receptorId: this.state.user._id,
                tipo: 'Venda',
                observacao: 'Venda recebida',
                status: true,
                natureza: 'ENTRADA',
                taxaComissao: this.state.pedidos[index].cartelas.length * this.state.user.comissao
            })
            this.state.transacaoCorrente = response.data
            this.setState({ transacaoCorrente: response.data })
        } catch (err) {
            console.log(err)
        }

        this.efetuarRecebimento(index)

    }

    async efetuarRecebimento(e) {
        const index = e
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('pedidos/receber-pedido', {
                codigo: this.state.pedidos[index].codigo,
                cambistaId: this.state.user._id,
                validado: this.state.pedidos[index].isApp,
                gerenteId: this.state.user.tutorId,
                transacaoId: this.state.transacaoCorrente._id
            })
            alert('Transação feita com sucesso!')
            setTimeout(async () => window.location.reload(), 1000)
        } catch (err) {
            console.log(err)
        }
    }



    async receberPedidoNaBusca(pedido) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('transacoes/criar-transacao', {
                data: new Date(),
                documento: pedido.codigo,
                valor: pedido.cartelas.length * pedido.cartelas[0].valor,
                emissorId: pedido.clienteId,
                receptorId: this.state.user._id,
                tipo: 'Venda',
                observacao: '',
                status: true,
                natureza: 'ENTRADA',
                taxaComissao: pedido.cartelas.length * this.state.user.comissao
            })
            this.state.transacaoCorrente = response.data
            this.setState({ transacaoCorrente: response.data })
        } catch (err) {
            console.log(err)
        }

        this.efetuarRecebimentoNaBusca(pedido)

    }

    async efetuarRecebimentoNaBusca(pedido) {
        try {
            var axiosInstance = new Axios.create({
                baseURL: window.localStorage.getItem('apiUrl')
            })
            const response = await axiosInstance.post('pedidos/receber-pedido', {
                codigo: pedido.codigo,
                cambistaId: this.state.user._id,
                gerenteId: this.state.user.tutorId,
                transacaoId: this.state.transacaoCorrente._id,
                validado: true
            })
            console.log(this.state.transacaoCorrente)
            alert('Transação feita com sucesso!')
            window.location.reload()
        } catch (err) {
            console.log(err)
        }
        this.listarPedidos()
    }



    async buscarPedido(e) {
        if (this.state.codigoBusca == null && this.state.codigoBusca == '') {
            alert('Digite um código antes de buscar!')
            return
        }
        else if(!this.state.user.status || this.state.user.tutorId.bloqVendas){
            alert('Vendas bloqueadas pelo gerente!')
            return
        }
        else{
            try {
                var axiosInstance = new Axios.create({
                    baseURL: window.localStorage.getItem('apiUrl')
                })
                const response = await axiosInstance.post('pedidos/buscar-pedido-por-codigo', {
                    codigo: this.state.codigoBusca,
                    cambistaId: this.state.user._id,
                })
                if (response.data == "Recebido") {
                    alert("O codigo já foi recebido por outro usuário!")
                    window.location.reload()
                }
                else if (response.data == "APP") {
                    alert("Você não pode receber pedidos gerados no APP")
                    window.location.reload()
                }
                else if (response.data.codigo == this.state.codigoBusca) {
                    alert('Recebido com sucesso!')
                    this.receberPedidoNaBusca(response.data)
                    // window.location.reload()
                } else {
                    alert('Codigo não encontrado!')
                }
    
    
            } catch (err) {
                console.log(err)
            }
        }

    }

    setCodigoBusca(e) {
        console.log(e.target.value)
        this.setState({ codigoBusca: e.target.value })
    }

    contarCartelas() {
        var cartelas = []
        this.state.pedidos.forEach(pedido => {
            pedido.cartelas.forEach(cartela => {
                cartelas.push(cartela)
            })
        })
        this.setState({ cartelas: cartelas })
    }

    render() {
        return (
            <CambistaTemplate label="Receber pedidos">
                <iframe id="printf" class='collapse' name="printf"></iframe>
                <div class="modal fade" id="exampleModalCenter" tabIndex="-1"
                    role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '95vw', marginTop: '-8em', zIndex: '3000 !important' }}
                        role="document">
                        <div class="modal-content " >
                            <div class="modal-header">
                                <h4 class="modal-title font-weight-bolder" id="exampleModalLongTitle">Detalhamento
                                    pedido</h4>
                                <button onClick={this.deselecionarPedido} type="button" class="close"
                                    data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                {this.state.pedidoSelecionado ?
                                    <DetalhamentoPedido user={this.state.clienteSelecionado}
                                        pedido={this.state.pedidoSelecionado} /> : ''}
                            </div>
                            <div class="modal-footer" style={{ justifyContent: 'flex-end' }}>

                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal fade" id="exampleModal" tabIndex="-1" role="dialog"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Efetuar recebimento</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <input  class="form-control" placeholder="Digite o código de pedido" name="codigo"
                                    onChange={this.setCodigoBusca}></input>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn-fill btn btn-secondary" data-dismiss="modal">Fechar
                                </button>
                                <button type="button" class="btn-fill btn btn-danger"
                                    onClick={this.buscarPedido}>Buscar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container-fluid">
                    <div className="row justify-content-end">
                        <button type="button" className="mr-5 mb-2 btn-fill btn btn-primary" data-toggle="modal"
                            data-target="#exampleModal">
                            Buscar pedido
                        </button>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="card strpied-tabled-with-hover">
                                <div className="card-header ">
                                    <h4 className="card-title">
                                        Atenção só receba pedidos, se estiver com o pagamento em mãos.
                                    </h4>
                                    <p className="card-category">Informações de pedidos.</p>
                                    <p className="card-category">Numero de cartelas : {this.state.cartelas.length}</p>
                                </div>
                                <div className="card-body table-full-width table-responsive">
                                    <table className="table table-hover table-striped">
                                        <thead>
                                            <tr>
                                                <th>Via</th>
                                                <th>Data</th>
                                                <th>Codigo</th>
                                                <th>Cliente</th>
                                                <th>Qtd de cartelas</th>
                                                <th>Valor total</th>
                                                <th>Recebimento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.pedidos != null
                                                ? Object.entries(this.state.pedidos).map(
                                                    (item, index) => {
                                                        return (
                                                            <tr className="align-items-center">
                                                                <td>{item[1].isApp? <i class="fas fa-mobile-alt" title="Sorteflash App 2.0"></i> : ''}</td>
                                                                <td 
                                                                
                                                                style={{ cursor: 'pointer' }}
                                                                accessKey={JSON.stringify(item[1])}
                                                                data-toggle={"modal"}
                                                                data-target={"#exampleModalCenter"}
                                                                onClick={this.selecionarPedido}

                                                                >{this.formatDate(item[1].data)}</td>
                                                                <td 
                                                                style={{ cursor: 'pointer' }}
                                                                accessKey={JSON.stringify(item[1])}
                                                                data-toggle={"modal"}
                                                                data-target={"#exampleModalCenter"}
                                                                onClick={this.selecionarPedido}
                                                                >{item[1].codigo}</td>
                                                                <td 
                                                                
                                                                style={{ cursor: 'pointer' }}
                                                                accessKey={JSON.stringify(item[1])}
                                                                data-toggle={"modal"}
                                                                data-target={"#exampleModalCenter"}
                                                                onClick={this.selecionarPedido}

                                                                >{item[1].clienteId.nome}</td>
                                                                <td
                                                                    className="d-inline-flex pl-5">
                                                                    <a>{item[1].cartelas.length}</a></td>
                                                                <td
                                                                    className="pl-4">
                                                                    <a>{item[1].cartelas[0] ? (item[1].cartelas.length * item[1].cartelas[0].valor).toFixed(2) : '0,00'}</a>
                                                                </td>
                                                                <td style={{ padding: 0}} unselectable="on" class="unselectable">
                                                                    <button
                                                                        name={index}
                                                                        className={
                                                                            item[1].recebido
                                                                                ? 'btn bg-success text-light btn-success border-0'
                                                                                : 'btn bg-warning text-light btn-warning border-0'
                                                                        }
                                                                        disabled={item[1].recebido}
                                                                        onClick={() => {
                                                                            if(!this.state.user.status || this.state.user.tutorId.bloqVendas){
                                                                                alert("Suas vendas foram bloquadas pelo gerente!")
                                                                                return;
                                                                            }else{
                                                                            this.receberPedido.bind(this)}
                                                                            }
                                                                        }
                                                                        style={{ cursor: 'pointer', zIndex: 3001 }}
                                                                    >
                                                                        {item[1].recebido
                                                                            ? 'Recebido'
                                                                            : 'Pendente'}
                                                                    </button>
                                                                </td>
                                                                <td>
                                                                    <button disabled={!item[1].recebido} onClick={this.imprimirPedido.bind(this)} class={"btn-fill btn btn-success"} accessKey={item[1]._id} style={{zIndex: 3001}} >IMPRIMIR</button>
                                                                    {/* <button disabled={!item[1].recebido} class={navigator.appVersion.toLocaleLowerCase().includes("gonative")? "btn-fill btn btn-success" : "collapse"} accessKey={JSON.stringify(item[1])} onClick={this.imprimirCartelasWebView}>IMPRIMIR</button> */}
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                )
                                                : ''}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CambistaTemplate>

        )
    }
}

export default ReceberPedidos
